import React from 'react';
import ProjectActivityLog from './ProjectActivityLog';

const ProjectActivityLogDemo = ({ projectId, imageGenerationTimestamp }) => {
    const sampleActivities = [
        {
            id: 1,
            type: 'Activity creation',
            title: "'Setup community solar panels' created",
            description: "The activity is about planning and executing on Gitcoin missions on Radio during GG20",
            date: '2024-02-01T00:00:00Z',
            media: []
        },
        {
            id: 2,
            type: 'Activity validation',
            title: "Funds worth $500 deployed",
            description: "80 submissions were validated, 40 Impact certificates were awarded & 4 claims rewarded",
            date: '2024-01-29T00:00:00Z',
            media: [
                {
                    type: 'video',
                    url: 'https://via.placeholder.com/300x200/4F46E5/FFFFFF?text=Video+1',
                    thumbnail: 'https://via.placeholder.com/300x200/4F46E5/FFFFFF?text=Video+1',
                    username: 'changemaker001',
                    impactPoints: '3000',
                    caption: 'Taken at 12:00 pm GMT +5:30, 22 Mar 2025, Indirangar Be...'
                },
                {
                    type: 'image',
                    url: 'https://via.placeholder.com/300x200/10B981/FFFFFF?text=Image+1',
                    username: 'tinawest12',
                    impactPoints: '2000',
                    caption: 'Community garden work'
                },
                {
                    type: 'image',
                    url: 'https://via.placeholder.com/300x200/8B5CF6/FFFFFF?text=Image+2',
                    username: 'avengers2554',
                    impactPoints: '1000',
                    caption: 'Water conservation project'
                }
            ]
        },
        {
            id: 3,
            type: 'Activity participation',
            title: "100 people participated in activity 'Write a blog on water shortage in Bengaluru'",
            description: "100 participants started the activity and 80 of them completed it",
            date: '2024-01-28T00:00:00Z',
            media: []
        },
        {
            id: 4,
            type: 'Activity creation',
            title: "'Write a blog on water shortage in Bengaluru' created",
            description: "Spread awareness about the water shortage in Bangalore providing historical and political context",
            date: '2024-01-27T00:00:00Z',
            media: []
        }
    ];

    return (
        <div className='my-12'>
            <ProjectActivityLog projectId={projectId} activities={sampleActivities} imageGenerationTimestamp={imageGenerationTimestamp} />
        </div>

    );
};

export default ProjectActivityLogDemo; 